import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import React from 'react';
import { useTranslation } from 'react-i18next';

const AlmostDoneComponent: React.FC = () => {
  const { t } = useTranslation('auth');
  return (
    <>
      <Typography variant="body1" sx={{ mt: 1 }}>
        {t('invite.almostDone')}
      </Typography>
      <Typography variant="body1" sx={{ mt: 1 }}>
        <Link href="/" variant="body2" sx={{ ml: 1 }}>
          {t('invite.logInLink')}
        </Link>
      </Typography>
    </>
  );
};
export default AlmostDoneComponent;
